/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Row,
  Col,
  Space,
  Descriptions,
  Table,
  Collapse,
  Tabs,
  Steps,
  Button,
  Flex,
  Drawer,
  Modal,
  Input,
  Tag,
  message,
} from "antd";

import {
  ArrowLeftOutlined,
  CopyOutlined,
  EditOutlined,
  PaperClipOutlined,
  StopOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import { FaTruckLoading } from "react-icons/fa";

// import SamplePreparationService from "../../service/SamplePreparation.service.js";
import JobOrderService from "../../../service/ERP/JobOrder.service.js";
import { capitalized } from "../../../utils/util.js";
import { detailColumnsView, remarkColumnsView } from "./model.js";
import FileControl from "../../file-control/FileControl.jsx";

import dayjs from "dayjs";

import ModalJOdetail from "../../../components/modal/ERP/jo-print-detail/ModalJO.jsx";
import ModalJODeliveryNote from "../../../components/modal/ERP/job-order/ModalJODeliveryNote.jsx";
import useGoBack from "../../../hooks/useGoBack";
import ActionGroup, { PrintButton, ACTION_BTN as AG_BTN } from "../../../components/action-group/ActionGroup";

const joService = JobOrderService();

export default function JobOrderView() {
  const navigate = useNavigate();
  const location = useLocation();

  const { config } = location.state || { config: null };
  const mngConfig = {
    title: "",
    textOk: null,
    textCancel: null,
    action: "create",
    code: null,
    version: 1,
  };

  const [masters, setMasters] = useState({});
  const [verNo, setVerNo] = useState(1);

  const defaultPanes = useMemo(
    () =>
      Array.from({ length: verNo }).map((_, index) => ({
        label: `Version ${verNo - 1 - index}`,
        key: verNo - 1 - index,
      })),
    [verNo],
  );

  const [version, setVersion] = useState(defaultPanes);

  const [activeKey, setActiveKey] = useState(defaultPanes[0].key);

  const [versionData, setVersionData] = useState([]);

  const [detail, setDetail] = useState([]);
  const [remark, setRemark] = useState([]);
  const [selectDataPrint, setSelectDataPrint] = useState([]);
  /* ลิ้นชักเก็บไฟล์จากลูกค้าของ Job นี้ */
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  /* ยกเลิกใบสั่งงาน — ทำได้เมื่อยังไม่ถูกดึงไปใช้ในเอกสารอื่น */
  const [cancelReason, setCancelReason] = useState("");

  const [openPrintDetail, setOpenPrintDetail] = useState(false);
  const [openDeliveryNote, setOpenDeliveryNote] = useState(false);

  const onChangeTab = (key) => {
    setActiveKey(key);
    // alert(versionData[key]);

    setMasters(versionData[key]);
    setDetail(versionData[key].detail);
    setRemark(versionData[key].remark);
  };

  const gettingPSPData = () => {
    joService.get(config?.code).then(async (res) => {
      const { result } = res.data;
      // console.log(result);

      setMasters(result[result.length - 1]);
      setDetail(result[result.length - 1].detail);
      setRemark(result[result.length - 1].remark);

      // console.log(result[result.length - 1].micro_para);

      setVersionData({ ...result });
      setVerNo(result.length);
      setActiveKey(result.length - 1);
    });
  };

  /* กลับไปหน้าที่กดรหัสเอกสารมา (รายการ JO หรือหน้ารายงาน) */
  const hendleClose = useGoBack("/ERP/job-order");

  const handleDuplicateJobOrder = () => {
    // alert(version.length);
    navigate("/ERP/job-order/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Duplicate Job Order",
          action: "duplicate",
          code: versionData[activeKey],
          version: version.length,
        },
      },
    });
  };

  const handleNewVersionJobOrder = () => {
    // alert(version.length);
    navigate("/ERP/job-order/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Duplicate Job Order",
          action: "copy",
          code: versionData[activeKey],
          version: version.length,
        },
      },
    });
  };

  const handleEditJobOrder = () => {
    navigate("/ERP/job-order/manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "Edit Job Order",
          action: "edit",
          code: versionData[activeKey],
          version: activeKey,
        },
      },
    });
  };

  const handlePrint = () => {
    // alert("กำลังอยู่ในระหว่างการพัฒนา");

    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/jo-print/${config?.code}/${activeKey}`;
  };

  const handlePrintInvoice = () => {
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/jo-invoice-print/${config?.code}/${activeKey}`;
  };

  const handleChoosedPrintDetail = (value) => {
    // const f = form.getFieldValue();
    // const initialValues = {
    //   ...f,
    //   cuscode: value.cuscode,
    //   cusname: value.cusname,
    // };
    // form.setFieldsValue(initialValues);
    // setFormDetail(initialValues);
    // getpgList(value.cuscode);
  };

  useEffect(() => {
    setVersion(defaultPanes);
  }, [defaultPanes]);

  useEffect(() => {
    // console.log(config);
    if (!config) {
      hendleClose();
      return;
    }
    gettingPSPData();

    return () => {};
  }, []);

  const PrintDetail = (v) => {
    setSelectDataPrint(v);
    setOpenPrintDetail(true);
    
    // alert("กำลังอยู่ในระหว่างการพัฒนา");
    // console.log(v);
  };

  const masterItems = [
    {
      label: "JO Code",
      children: masters?.jocode,
    },
    {
      label: "JO Date",
      children: dayjs(masters?.jodate).format("DD/MM/YYYY"),
    },
    {
      label: "Brand",
      children: masters?.brand,
    },
    { label: "Customer Code", children: masters?.cuscode },
    {
      label: "Customer Name",
      children: masters?.cusname,
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    {
      label: "ETL",
      children: masters?.etl ? dayjs(masters?.etl).format("DD/MM/YYYY") : "",
    },
    {
      label: "ETD",
      children: masters?.etd ? dayjs(masters?.etd).format("DD/MM/YYYY") : "",
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    {
      label: "Actual ETD",
      children: masters?.act_etd ? dayjs(masters?.act_etd).format("DD/MM/YYYY") : "",
    },
    {
      label: "Actual ETL",
      children: masters?.act_etl ? dayjs(masters?.act_etl).format("DD/MM/YYYY") : "",
      span: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 },
    },
    { label: "PO ลูกค้า", children: masters?.pi_no },
    { label: "Loading Type", children: masters?.shipment },
    { label: "สร้างโดย", children: masters?.created_name },
    // {
    //   label: "Options",
    //   labelStyle: { verticalAlign: "top" },
    //   children: (
    //     <Flex gap="small">
    //       <Button
    //         style={{ width: 300 }}
    //         className="bn-center bn-success-outline bn-bold bn-action"
    //         size="small"
    //         icon={<TbFileCertificate />}
    //         onClick={() => handlePlPrint(masters.pgcode)}
    //       >
    //         {" "}
    //         Packing Information PG
    //       </Button>
    //       {/* <Button 
    //                                 style={{ width: 120 }} 
    //                                 className='bn-center bn-warning-outline bn-bold bn-action' 
    //                                 size='small' 
    //                                 icon={<TbFileCertificate />} 
    //                                 onClick={() => handleLotPrint(master.spcode)} 
    //                             > LOI </Button> */}
    //     </Flex>
    //   ),
    //   span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    // },
  ];

  const remarkItems = [
    {
      key: "1",
      label: "ข้อกำหนดพิเศษ",
      children: (
        <>
          <Table
            style={{ backgroundColor: "#fafafa" }}
            bordered
            dataSource={remark}
            columns={remarkColumnsView}
            pagination={false}
            rowKey="seq"
            scroll={{ x: "max-content" }}
            size="small"
          />
        </>
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  const customerItems = [
    {
      key: "1",
      label: "รายการสินค้า Job Order",
      children: (
        <>
          <Table
            style={{ backgroundColor: "#fafafa" }}
            bordered
            dataSource={detail}
            columns={detailColumnsView({ PrintDetail })}
            pagination={false}
            rowKey="seq"
            scroll={{ x: "max-content" }}
            size="small"
            summary={(v) => (
              <>
                {v.length > 0 && (
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={7} align="right">
                      รวม
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={1} align="right">
                      {v
                        .reduce((a, x) => a + Number(x?.carton || 0), 0)
                        .toLocaleString("en-US")}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={2} align="right">
                      {v
                        .reduce(
                          (a, x) =>
                            a +
                            Number(x?.carton || 0) * Number(x?.unit_cs || 0),
                          0,
                        )
                        .toLocaleString("en-US")}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={3} align="right">
                      {(() => {
                        const sum = v.reduce((a, x) => a + Number(x?.total_pd || 0), 0);
                        const totalUnit = v.reduce((a, x) => a + Number(x?.carton || 0) * Number(x?.unit_cs || 0), 0);
                        if (sum <= 0) return <span style={{ color: "#bfbfbf" }}>-</span>;
                        const done = totalUnit > 0 && sum >= totalUnit;
                        return (
                          <span style={{ color: done ? "#52c41a" : "#1677ff", fontWeight: 600 }}>
                            {sum.toLocaleString("en-US")}
                          </span>
                        );
                      })()}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={4} colSpan={4} />
                  </Table.Summary.Row>
                )}
              </>
            )}
          />
        </>
      ),
      disabled: true,
      showArrow: false,
    },
  ];

  /** settimg child component */
  const ButtonActionSrDetailLeft = (
    <Space
      gap="small"
      align="center"
      style={{ display: "flex", justifyContent: "start" }}
    >
      <Button
        style={{ width: 120 }}
        icon={<ArrowLeftOutlined />}
        onClick={() => {
          hendleClose();
        }}
      >
        กลับ
      </Button>
    </Space>
  );

  const isCancelled = masters?.doc_status === "ยกเลิก";

  const handleCancelJo = () => {
    const jocode = masters?.jocode;
    if (!jocode) return;

    joService
      .cancelCheck(jocode)
      .then((res) => {
        const { can_cancel, used } = res.data?.data || {};
        if (!can_cancel) {
          Modal.error({
            title: "ยกเลิกใบสั่งงานไม่ได้",
            content: (
              <div>
                <p>ใบสั่งงานนี้ถูกดึงไปใช้แล้วใน</p>
                <ul style={{ paddingLeft: 18 }}>
                  {(used || []).map((u, i) => (
                    <li key={i}>
                      {u.doc}
                      {u.codes?.length > 0 ? ` : ${u.codes.join(", ")}` : ""}
                    </li>
                  ))}
                </ul>
              </div>
            ),
          });
          return;
        }

        setCancelReason("");
        Modal.confirm({
          title: `ยกเลิกใบสั่งงาน ${jocode}?`,
          content: (
            <div>
              <p>ใบนี้ยังไม่ถูกดึงไปใช้ที่ไหน สามารถยกเลิกได้</p>
              <Input.TextArea
                rows={2}
                placeholder="เหตุผลที่ยกเลิก (ไม่บังคับ)"
                onChange={(e) => setCancelReason(e.target.value)}
              />
            </div>
          ),
          okText: "ยกเลิกใบสั่งงาน",
          okButtonProps: { danger: true },
          cancelText: "ไม่ยกเลิก",
          onOk: () =>
            joService
              .cancelJo(jocode, cancelReason)
              .then((r) => {
                message.success(r.data?.message || "ยกเลิกเรียบร้อย");
                gettingPSPData();
              })
              .catch((err) =>
                message.error(err?.response?.data?.message || "ยกเลิกไม่สำเร็จ")
              ),
        });
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "ตรวจสอบสถานะไม่สำเร็จ")
      );
  };

  const handleUncancelJo = () => {
    const jocode = masters?.jocode;
    Modal.confirm({
      title: `คืนสถานะใบสั่งงาน ${jocode}?`,
      content: "ใบสั่งงานจะกลับไปเป็น 'รอดำเนินการ'",
      okText: "คืนสถานะ",
      cancelText: "ปิด",
      onOk: () =>
        joService
          .uncancelJo(jocode)
          .then((r) => {
            message.success(r.data?.message || "คืนสถานะเรียบร้อย");
            gettingPSPData();
          })
          .catch((err) =>
            message.error(err?.response?.data?.message || "คืนสถานะไม่สำเร็จ")
          ),
    });
  };

  const ButtonActionSrDetailRight = (
    <>
      <Space
        gap="small"
        align="center"
        className="flex justify-start lg:justify-end md:justify-end"
      >
        <Flex gap={6} wrap="wrap" align="center">
          <ActionGroup type="print">
            {!isCancelled && <PrintButton onClick={handlePrint}>Print Job Order</PrintButton>}
          </ActionGroup>
          <ActionGroup type="action">
            <Button type="primary" className="bn-center justify-center" style={AG_BTN} icon={<CopyOutlined />} onClick={handleDuplicateJobOrder}>
              Duplicate Job Order
            </Button>
            {!isCancelled && (
              <Button type="primary" className="bn-center justify-center" style={AG_BTN} icon={<CopyOutlined />} onClick={handleNewVersionJobOrder}>
                New Version JO
              </Button>
            )}
            {!isCancelled && (
              <Button
                className="bn-center justify-center"
                style={{ ...AG_BTN, borderColor: "#52c41a", color: "#fff", background: "#52c41a" }}
                icon={<EditOutlined />}
                onClick={handleEditJobOrder}
              >
                Edit Job Order
              </Button>
            )}
            {/* เก็บไฟล์จากลูกค้า เช่น PO / อาร์ตเวิร์ก / เอกสารประกอบของ Job นี้ */}
            <Button
              className="bn-center justify-center"
              style={{ ...AG_BTN, borderColor: "#13c2c2", color: "#fff", background: "#13c2c2" }}
              icon={<PaperClipOutlined />}
              onClick={() => setIsOpenUpload(true)}
            >
              ไฟล์แนบลูกค้า
            </Button>
            {isCancelled ? (
              <Button className="bn-center justify-center" style={AG_BTN} icon={<RollbackOutlined />} onClick={handleUncancelJo}>
                คืนสถานะ
              </Button>
            ) : (
              <Button danger className="bn-center justify-center" style={AG_BTN} icon={<StopOutlined />} onClick={handleCancelJo}>
                ยกเลิก JO
              </Button>
            )}
          </ActionGroup>
        </Flex>
      </Space>
    </>
  );

  // console.log('Current count:', detailItemsActive);
  return (
    <>
      <Space
        direction="vertical"
        size="middle"
        style={{
          display: "flex",
          position: "relative",
          paddingInline: "1.34rem",
        }}
        className="sample-preparation-view"
      >
        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="m-0"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailRight}
          </Col>
        </Row>

        <Tabs
          hideAdd
          onChange={onChangeTab}
          activeKey={activeKey}
          type="card"
          // onEdit={onEdit}
          items={version}
        />

        <Descriptions
          bordered
          column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
          items={masterItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={customerItems}
        />

        <Collapse
          size="large"
          className="view-collapse-sp"
          collapsible="disabled"
          activeKey={"1"}
          bordered={false}
          style={{ backgroundColor: "transparent" }}
          items={remarkItems}
        />

        <Row
          gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
          className="mx-0 mb-4"
        >
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="px-0">
            {ButtonActionSrDetailLeft}
          </Col>
        </Row>
      </Space>

      {openPrintDetail && (
        <ModalJOdetail
          show={openPrintDetail}
          close={() => setOpenPrintDetail(false)}
          values={selectDataPrint}
          jocode={masters.jocode}
        />
      )}

      <Drawer
        title="ไฟล์แนบจากลูกค้า"
        placement="right"
        size="large"
        open={isOpenUpload}
        onClose={() => setIsOpenUpload(false)}
      >
        {isOpenUpload && (
          <FileControl
            title={`แนบไฟล์ สำหรับ Job Order : ${masters?.jocode || ""}`}
            refcode={masters?.jocode}
            refs="Job Order"
            noExpire={true}
            multiple={true}
          />
        )}
      </Drawer>

      {openDeliveryNote && (
        <ModalJODeliveryNote
          show={openDeliveryNote}
          close={() => setOpenDeliveryNote(false)}
          jocode={masters?.jocode}
        />
      )}
    </>
  );
}
